<template>
  <div class='screen-admin-page screen-admin-usaga-report trail-info'>
    <div>
        <div class="toolbar">
            <div class="title">
                <h1>Free Trial Packages</h1>
            </div>
            <AddFreeTrialPackage />
        </div>
    </div>
    <div class="filterables">
    <div class="filter-container">
      <ul class="filter-items">
        <li
          v-for="item in filterables"
          :key="item"
          :class="{
            active: values.title === item,
            selectable: !item.isCheckbox,
            selected: item.selected,
            hr: item.key === '-',
        }"
          @click="onSelectedFilteritem(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <rz-request-state :state="state" />
    <div
      class="usage-report admin-screen-content"
      v-if="state.status.isLoaded"
    >
    <div class="table-block">
          <div class="item-list-row item-list">
            <FreeTrialInfoTable
              :title="values.title"
              :freeTrialPackages="freeTrialPackages.free_trial_packages"
            />
          </div>
          <div
            class="filter-pagination"
          >
            <div
              class="arrow left"
              :class="[freeTrialPackages.pagination_params.current_page !== 1 ? null : 'disable']"
              @click="prevPage()"
            ></div>
            <div class="page-number">{{freeTrialPackages.pagination_params.current_page}}</div>
            <div
              class="arrow right"
              :class="[freeTrialPackages.pagination_params.current_page
              !== freeTrialPackages.pagination_params.total_pages ? null : 'disable']"
              @click="nextPage()"
            ></div>
          </div>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  onMounted,
  watch,
} from 'vue';
import { RequestState, RequestStateStatus } from '@/api/core';
import AddFreeTrialPackage from '@/components/admin/AddFreeTrialPackage.vue';
import { ProjectList } from '@/store/modules/admin';
import FreeTrialInfoTable from '@/components/admin/FreeTrialInfoTable.vue';

export default {
  components: {
    AddFreeTrialPackage,
    FreeTrialInfoTable,
  },
  setup() {
    const state = ref(new RequestState());
    const freeTrialPackages = ref({});
    const filterables = ref([
      'Active Trial Packages',
      'Expired Trial Packages',
    ]);
    const title = ref('Free Trial Packages');

    const values = reactive({
      show_active: true,
      title: 'Active Trial Packages',
    });

    const onSelectedFilteritem = (item) => {
      if (item === 'Active Trial Packages') {
        values.show_active = true;
        values.title = 'Active Trial Packages';
      } else {
        values.show_active = false;
        values.title = 'Expired Trial Packages';
      }
    };

    const fetchData = (val) => {
      state.value.status = RequestStateStatus.Loading;
      const params = val ?? {
        active: values.show_active,
        page: 1,
      };
      return ProjectList.fetchFreeTrialPackages(params).then((resp) => {
        freeTrialPackages.value = resp;
        state.value.status = RequestStateStatus.Loaded;
      }).catch((err) => {
        state.value.ref = err;
        state.value.status = RequestStateStatus.Error;
      });
    };

    const prevPage = () => {
      if (freeTrialPackages.value.pagination_params.current_page === 1) {
        return;
      }
      const pageNum = freeTrialPackages.value.pagination_params.current_page - 1;
      const params = {
        page: pageNum,
        active: values.show_active,
      };
      fetchData(params);
    };
    const nextPage = () => {
      if (
        freeTrialPackages.value.pagination_params.current_page === freeTrialPackages.value.pagination_params.total_pages
      ) {
        return;
      }
      const pageNum = freeTrialPackages.value.pagination_params.current_page + 1;
      const params = {
        page: pageNum,
        active: values.show_active,
      };
      fetchData(params);
    };

    onMounted(() => {
      fetchData();
    });

    watch(() => values && values.show_active, () => {
      fetchData();
    });

    return {
      freeTrialPackages,
      state,
      filterables,
      values,
      title,
      onSelectedFilteritem,
      prevPage,
      nextPage,
    };
  },
};
</script>
<style lang="scss">
.trail-info {
  padding: size(20);
  .filterables{
    margin: 0 size(30);
    .filter-container {
        flex: 0 0 size(250);
    }
  }
  .filter-pagination {
    display: flex;
    justify-content: end;
    margin-bottom: size(50);
    .arrow {
      border-radius: size(5);
      border: size(1) solid var(--global--primary--Color);
      cursor: pointer;
      display: inline-block;
      &:after {
        content: '';
        border: solid var(--global--white--Color);
        border-width: 0 size(2) size(2) 0;
        display: inline-block;
        padding: size(3);
        vertical-align: middle;
      }
      &.left {
        padding: size(10) size(12) size(10) size(14);
        &:after {
          transform: rotate(135deg);
          -webkit-transform: rotate(135deg);
        }
      }
      &.right {
        padding: size(10) size(14) size(10) size(12);
        &:after {
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        }
      }
      &:hover {
        @include jump-up-animation;
      }
      &.disable {
        border: size(1) solid var(--global--gray--Color);
        cursor: not-allowed;
        &:after {
          border: solid var(--global--gray--Color);
          border-width: 0 size(2) size(2) 0;
        }
        &:hover {
          animation: none;
        }
      }
      }
    .page-number {
      margin: auto size(20);
    }
  }
  .table-block {
    display: inline-block;
    vertical-align: top;
    min-width: size(800);
    .item-list {
      padding-top: 0;
      table {
        tr {
          td {
            &:first-child{
              cursor: default;
              button {
                cursor: default;
              }
            }
          }
        }
      }
    }
  }
}
</style>
